import React, { Fragment } from 'react'
import TideeLogo from 'tidee-life-ui/dist/src/tidee-logo.js'

type TLogo = {
    align?: string
    bold?: boolean
    reverse?: boolean
    size: number
    src?: string
}

const Logo = ({ align, bold, reverse, size = 33, src, ...rest }: TLogo) => {
    return (
        <Fragment>
            {src && (
                <div
                    style={{
                        display: 'flex',
                        alignContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            flex: 0,
                            alignSelf: 'center',
                            paddingRight: '5px',
                        }}
                    >
                        <img alt="tidee" src={src} height={27} width={27} />
                    </div>
                    <div style={{ flex: 1 }}>
                        <TideeLogo
                            align={align}
                            bold={bold}
                            reverse={reverse}
                            size={size}
                            {...rest}
                        >
                            tidee
                        </TideeLogo>
                    </div>
                </div>
            )}
            {!src && (
                <TideeLogo
                    align={align}
                    bold={bold}
                    reverse={reverse}
                    size={size}
                    {...rest}
                >
                    tidee
                </TideeLogo>
            )}
        </Fragment>
    )
}

export default Logo
